import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionCustomerListItemProps } from '..';
import { HintButton } from '../../../../../../../components/HintButton';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';

export const SubscriptionCustomerListItemMobile: React.FC<SubscriptionCustomerListItemProps> = ({
  subscriptionCustomer,
  quantity,
  setQuantity,
  onSolicit,
  isDisabled,
  disabledMessage,
}) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack justifyContent="space-between" space="stack.xxxs">
          <VStack space="stack.quarck">
            <UI.Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
              Cliente
            </UI.Text>
            <UI.Text color="neutral.darkest" variant="semibold">
              {subscriptionCustomer.customerNameNormalized}
            </UI.Text>
          </VStack>
          <HStack justifyContent="space-between" space="inline.nano">
            <VStack w="3/5">
              <UI.Text>Assessor</UI.Text>
              <UI.Text color="neutral.darkest">
                {subscriptionCustomer.advisorNameNormalized}
              </UI.Text>
            </VStack>
            <VStack w="2/6">
              <UI.Text>Telefone</UI.Text>
              <UI.Text color="neutral.darkest">
                {subscriptionCustomer.phoneNumberNormalized}
              </UI.Text>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between" space="inline.nano">
            <VStack w="3/5">
              <UI.Text>E-mail</UI.Text>
              <UI.Text color="neutral.darkest">{subscriptionCustomer.emailNormalized}</UI.Text>
            </VStack>
            <VStack w="2/6">
              <UI.Text>Qtde. Disponível</UI.Text>
              <UI.Text color="neutral.darkest">{`${subscriptionCustomer.availableQuantity}`}</UI.Text>
            </VStack>
          </HStack>
          <VStack space="stack.quarck">
            <UI.Text>Quantidade</UI.Text>
            <UI.InputStepper
              max={subscriptionCustomer.availableQuantity}
              min={1}
              name="quantity"
              defaultValue={quantity}
              onChange={setQuantity}
              stepperValue={1}
              disabled={isDisabled}
            />
          </VStack>
          <HintButton
            tooltip={disabledMessage}
            variant="textLink"
            alignSelf="end"
            isDisabled={isDisabled}
            _text={{
              color: 'brand.tertiary.principal',
              fontFamily: Typography['fontfamily.base.semibold'],
            }}
            onPress={onSolicit}
            rightIcon={
              <UI.Icon name="ChevronRight" size="xxxs" color="brand.tertiary.principal" />
            }>
            SOLICITAR
          </HintButton>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
